<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading">
    <div *ngIf="!showAccountSelection">
      <div class="banner" *ngIf="backNavigationAllowed()">
        <img src="assets/icon/Arrow-Left.svg" alt="" class="back-button" (click)="reroute()"/>
        <span class="back-text" (click)="reroute()">Tillbaka</span>
      </div>
      <div class="contents-wrapper">
        <div class="contents-container">
          <div class="extra-padding">
            <div class="heading">
              Vänligen kontrollera att nedanstående detaljer för betalning är korrekta.
            </div>
          </div>

          <div>
            <hr class="details-divider" />
            <div class="details-container">
              <div class="details-key-entry">
                {{ state.paymentInformation.title }}
              </div>
              <div class="details-value-entry details">
                <zaver-button-link text="Detaljer" (click)="showPurchaseDetails()"></zaver-button-link>
              </div>
            </div>

            <hr class="details-divider" />

            <div class="details-container">
              <div class="details-key-entry">
                {{ getBankDisplayName(selectedAccount?.bankName) }}
              </div>
              <div class="details-value-entry details">
                {{ selectedAccount?.displayAccountNumber }}
              </div>
            </div>

            <hr class="details-divider" />

            <div class="change-bank-account">
              <zaver-button-link text="Byt bank eller konto" (click)="changeAccount()"></zaver-button-link>
            </div>
          </div>

          <div class="details-container">
            <div class="details-key-entry">
              Totalbelopp
            </div>
            <div class="details-value-entry details">
              {{ getTotalAmount() }}
            </div>
          </div>

          <div class="button-container">
            <zaver-primary-button [buttonType]="'submit'" [formId]="'email-and-phone-form'" text="Slutför"
              (click)="handleCtaClick()"></zaver-primary-button>
          </div>

          <div class="terms-text">
            Genom att fortsätta bekräftar du att du har tagit del av och godkänner {{state.checkoutCustomizations.merchantName}} betalningsvillkor 
            samt lämnar ett autogiromedgivande till Zaver enligt 
            <zaver-button-link text="villkoren för Autogiro" (click)="showTerms()"></zaver-button-link>.
          </div>
        </div>
      </div>
    </div>


    <div *ngIf="showAccountSelection">
      <div *ngIf="!loading" class="banner">
        <img src="assets/icon/Arrow-Left.svg" alt="" class="back-button" (click)="hideAccountSelection()" />
      </div>
      <div class="contents-wrapper">
        <div class="contents-container">
          <div class="heading extra-padding">
            Autogiro
          </div>

          <div class="sub-heading">
            Välj vilket av dina anslutna konton som du vill använda för detta köp.
          </div>

          <div class="heading">
            Anslutna bankkonton
          </div>

          <div class="account-selection-list">
            <div *ngFor="let account of accounts" class="account-row" (click)="onAccountRadioSelect(account.id)">

              <div class="radio-container">
                <div class="custom-radio" [class.selected]="tempSelectedAccountId === account.id"></div>
              </div>

              <div class="account-details">
                <div class="bank-name">{{ getBankDisplayName(account.bankName) }}</div>
                <div class="account-number">{{ account.displayAccountNumber }}</div>
              </div>
            </div>
          </div>

          <div style="text-align: center; margin-bottom: 32px;">
            <zaver-button-link text="Lägg till ett nytt bankkonto" (click)="selectNewAisAccount()"></zaver-button-link>
          </div>

          <div class="button-container">
            <zaver-primary-button text="OK" (click)="handleAccountSelectionSubmit()"></zaver-primary-button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <zaver-checkout-modal *ngIf="selectorItems && modalActive" [buttonText]="'Stäng'" [title]="'Visa detaljer'"
    (onClose)="toggleModal()">
    <app-selector #selector [selectorItems]="selectorItems" [selectedItem]="selectedItem"></app-selector>
  </zaver-checkout-modal>